"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var devices = [
    {
        regex: /iPhone/i,
        type: 'phone',
    }, {
        regex: /iPod/i,
        type: 'phone',
    }, {
        regex: /iPad/i,
        type: 'tablet',
    }, {
        regex: /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,
        type: 'phone',
    }, {
        regex: /Android/i,
        type: 'tablet',
    }, {
        regex: /Windows Phone/i,
        type: 'phone',
    }, {
        regex: /(?=.*\bWindows\b)(?=.*\bARM\b)/i,
        type: 'tablet',
    }, {
        regex: /(BlackBerry|BB10)/i,
        type: 'phone',
    }, {
        regex: /Opera Mini/i,
        type: 'phone',
    }, {
        regex: /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        type: 'phone',
    }, {
        regex: /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
        type: 'phone',
    },
];
exports.identifyDeviceType = function (userAgent) {
    if (userAgent) {
        for (var i = 0; i < devices.length; i++) {
            var device = devices[i];
            if (device.regex.test(userAgent)) {
                return device.type;
            }
        }
    }
    return 'desktop';
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/device.ts
// module id = 6
// module chunks = 0